export default function changeMyPass(values) {
  const query = `mutation{
    changeMyPass(currentPass:"${values.currentPass}", newPass:"${values.newPass}")
}`;

  return query;
}
